import http from '../../http'

const API_URL = "responsibility-plan" 
const API_URL_DETAIL = "responsibility-plan"

class ResponsabilityPlanAPI {

  // CRUD functions
 
  async save(plan) {
    const response = await http(`${API_URL}/save`, 'POST', plan)
    return response
  }

  async getAll(companyID, page) {
    const response = await http(`${API_URL}/${companyID}?page=${page}`)
    return response || null
  } 

  async get(planID) {
    const response = await http(`${API_URL}/${planID}`)
    return response || null
  }
  async getID(planID) {
    const response = await http(`${API_URL}/show/${planID}`)
    return response || null
  }

  async last(companyID) {
    const response = await http(`${API_URL}/recent/${companyID}`)
    return response || null
  }

  async update(id, plan) {
    const response = await http(`${API_URL}/edit/${id}`, 'PUT', plan)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/destroy/${id}`, 'DELETE')
    return response
  }

  // Standards

  async standard111(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-111/${companyID}`)
    return response || null
  }

  async standard116(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-116/${companyID}`)
    return response || null
  }

  async standard118(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-118/${companyID}`)
    return response || null
  }

  async standard121(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-121/${companyID}`)
    return response || null
  }

  async standard211(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-211/${companyID}`)
    return response || null
  }

  async standard311(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-311/${companyID}`)
    return response || null
  }

  async standard312(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-312/${companyID}`)
    return response || null
  }

  async standard412(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-412/${companyID}`)
    return response || null
  }

  async standard425(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-425/${companyID}`)
    return response || null
  }

  async standard426(companyID) {
    const response = await http(`${API_URL_DETAIL}/standard-426/${companyID}`)
    return response || null
  }
    
}

export default new ResponsabilityPlanAPI()